if (!customElements.get('glossary-bar')) {
  customElements.define(
    'glossary-bar',
    class GlossaryBar extends HTMLElement {
      constructor() {
        super()
      }

      connectedCallback() {
        const letterAnchors = this.querySelectorAll('.glossary-bar--letter')
        letterAnchors.forEach((letterAnchor) => {
          const letter = letterAnchor.dataset.letter
          const anchorTarget = document.querySelector(
            `.glossary-grid__head[data-letter="${letter}"]`
          )
          if (!anchorTarget) {
            letterAnchor.setAttribute('disabled', 'disabled')
          } else {
            const scrollToTarget = (e) => {
              e.preventDefault()
              window.scrollTo({
                top: anchorTarget.offsetTop - 160,
                behavior: 'smooth',
              })
            }

            letterAnchor.addEventListener('click', scrollToTarget)
            letterAnchor.addEventListener('keydown', (e) => {
              if (e.key === 'Enter') {
                scrollToTarget(e)
              }
            })
          }
        })
      }
    }
  )
}

if (!customElements.get('section-glossary')) {
  customElements.define(
    'section-glossary',
    class Glossary extends HTMLElement {
      constructor() {
        super()
        this.blazeSlider = null
        this._classObserver = null
      }

      connectedCallback() {
        this.sortGridItems()
        this.sortSlides()
        this.initSlider()

        this.slideArrows.forEach((element) => {
          element.addEventListener('click', this.onArrowClicked.bind(this))
        })

        const broadcasts = this.querySelectorAll('.glossary-item hh-broadcast')
        broadcasts.forEach((element, index) => {
          element.addEventListener('click', () => {
            this.goToSlide(index)
          })
          const hash = element.getAttribute('hash')
          const data = element.getAttribute('data')
          if (hash && data) {
            if (hash == window.location.hash.replace('#', '')) {
              document.dispatchEvent(
                new CustomEvent(`${hash}:open`, { detail: JSON.parse(data) })
              )
              this.goToSlide(index)
            }
          }
        })
      }

      disconnectedCallback() {
        if (this.blazeSlider) {
          this.blazeSlider.destroy()
          this.blazeSlider = null
        }
        if (this._classObserver) {
          this._classObserver.disconnect()
          this._classObserver = null
        }
      }

      sortGridItems() {
        let container = this.querySelector('.glossary-grid__inner')
        let elements = Array.from(container.children)
        let sorted = elements.sort(function (a, b) {
          return +a.dataset.order - +b.dataset.order
        })
        container.innerHTML = ''
        sorted.forEach((elm) => container.append(elm))
      }

      sortSlides() {
        let track = this.querySelector('.blaze-track')
        if (!track) return
        let slides = Array.from(track.children)
        let sorted = slides.sort(function (a, b) {
          return +a.dataset.order - +b.dataset.order
        })
        track.innerHTML = ''
        sorted.forEach((elm) => track.append(elm))
      }

      initSlider() {
        const sliderEl = this.querySelector('.js-glossary-slider')
        if (!sliderEl) return

        if (typeof window.BlazeSlider === 'undefined') {
          const script = document.querySelector('script[src*="blaze-slider"]')
          if (script) {
            script.addEventListener('load', () => this.initSlider(), { once: true })
          }
          return
        }

        this.blazeSlider = new window.BlazeSlider(sliderEl, {
          all: {
            enableAutoplay: false,
            enablePagination: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            transitionDuration: 300,
            transitionTimingFunction: 'ease-in-out',
            loop: false,
            draggable: false,
            slideGap: '0px',
          },
        })

        this.syncNavigationState()
        this.observeForDragSwipe(sliderEl)
      }

      goToSlide(index) {
        if (!this.blazeSlider) return
        const current = this.blazeSlider.stateIndex
        const diff = index - current
        if (diff === 0) return
        if (diff > 0) {
          this.blazeSlider.next(diff)
        } else {
          this.blazeSlider.prev(Math.abs(diff))
        }
        this.syncNavigationState()
      }

      observeForDragSwipe(sliderEl) {
        if (this._classObserver) {
          this._classObserver.disconnect()
        }
        this._classObserver = new MutationObserver(() => {
          this.syncNavigationState()
        })
        this._classObserver.observe(sliderEl, {
          attributes: true,
          attributeFilter: ['class'],
        })
      }

      syncNavigationState() {
        const atStart = this.blazeSlider && this.blazeSlider.stateIndex === 0
        const atEnd = this.blazeSlider && this.blazeSlider.states &&
          this.blazeSlider.stateIndex >= this.blazeSlider.states.length - 1

        this.querySelectorAll('.js-slide-arrow').forEach((button) => {
          button.removeAttribute('disabled')
          if (atEnd && button.getAttribute('data-direction') === 'next') {
            button.setAttribute('disabled', true)
          }
          if (atStart && button.getAttribute('data-direction') === 'prev') {
            button.setAttribute('disabled', true)
          }
        })
      }

      onArrowClicked(event) {
        if (!this.blazeSlider) return
        const direction = event.currentTarget.getAttribute('data-direction') || 'prev'
        if (direction === 'prev') {
          this.blazeSlider.prev()
        } else {
          this.blazeSlider.next()
        }
        this.syncNavigationState()
      }

      get slideArrows() {
        return this.querySelectorAll('.js-slide-arrow')
      }
    }
  )
}
